import { Theme } from '@mui/material';

const useStyles = (theme: Theme) => ({
  settingsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    width: '100%',
  },
  jpdaTitle: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    padding: '8px 16px',
  },
  helperContainer: {
    display: 'flex',
    width: '100%',
    justifyContent: 'flex-end',
    alignItems: 'center',
    py: '4px',
    gap: '4px',
    cursor: 'pointer',
    borderRadius: '4px',
    border: `1px solid ${theme.palette.grey[100]}`,
    background: theme.palette.secondary.main,
  },
  sectionSubMenu: {
    container: {
      display: 'flex',
      flexDirection: 'column',
      padding: '8px',
      alignItems: 'center',
      gap: '8px',
      alignSelf: 'stretch',
      borderRadius: '4px',
      background: '#F0F0F0',
    },
    content: {
      display: 'flex',
      // padding: '8px',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'flex-start',
      gap: '8px',
      alignSelf: 'stretch',
    },
    row: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'flex-start',
      alignSelf: 'stretch',
    },
    btnGrp: {
      display: 'flex',
      flexDirection: 'row',
      gap: '4px',
      alignItems: 'center',
      justifyContent: 'space-between',
      width: '100%',
    },
  },
  sectionSubGroupContainer: {
    display: 'flex',
    padding: '12px 8px 8px 8px',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
    gap: '2px',
    alignSelf: 'stretch',
    borderRadius: '4px',
    background: '#F0F0F0',
  },
  sectionSubGroupBtn: {
    container: {
      display: 'flex',
      padding: '8px',
      alignItems: 'center',
      gap: '16px',
      cursor: 'pointer',
      width: '100%',
      justifyContent: 'flex-start',
      textAlign: 'left',
      // The icons draw in currentColor, so the row sets their colour.
      '& svg': { color: theme.palette.grey[500], flexShrink: 0 },
      ':hover': {
        backgroundColor: theme.palette.common.white,
        color: theme.palette.primary.main,
        '& svg': { color: theme.palette.primary.main },
      },
    },
    txtContainer: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
    },
    txtTitle: {
      fontSize: '12px',
      fontWeight: 600,
      color: '#474747',
    },
    txtSubTitle: {
      fontSize: '12px',
      fontWeight: 400,
      color: '#707070',
    },
  },
  modal: {
    content: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: '16px',
      padding: '16px',
      maxHeight: '600px',
      minWidth: '450px',
      overflowY: 'scroll',
      overflowX: 'hidden',
      width: '100%',
    },
    controllerWrapper: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
    },
    radioGroupWrapper: {
      border: '1px solid #E0E0E0',
      borderRadius: '4px',
      paddingRight: '8px',
      marginLeft: 'unset',
      width: '100%',
      my: '4px',
    },
    footer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      padding: '16px',
      mt: '10px',
    },
    footerWrapper: {
      display: 'flex',
      width: '100%',
      gap: '8px',
    },
    labelWrapper: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      minWidth: '320px',
    },
    textWrapper: {
      display: 'flex',
      alignItems: 'flex-start',
      flex: '1 0 0',
    },
  },
});

export default useStyles;
